var PromiseUtil = {

    resolved: function (data) {
        var deferred = new $.Deferred();
        deferred.resolve(data);
        return deferred.promise();
    },

    rejected: function (data) {
        var deferred = new $.Deferred();
        deferred.reject(data);
        return deferred.promise();
    },

    isResolved: function (prom) {
        return prom.state() === 'resolved';
    },

    isPending: function (prom) {
        return prom.state() === 'pending';
    }
};

!function (GlobalSettings) {
    var toMoney = window.toMoney;
    window.toMoney = function (data, currencySign) {
        return toMoney(data, currencySign || GlobalSettings.CurrencySign);
    };
}(GlobalSettings);